import React, { useContext, useState, useEffect, memo, useRef } from "react";
import { useParams, Redirect } from "react-router-dom";
import { Grid, Box, CircularProgress } from "@material-ui/core";
import WizardStep from "../../components/WizardStep/WizardStep";
import PageTitle from "../../components/PageTitle/PageTitle";
import { GeneralContext } from "../../contexts/GeneralContext";
import { toast } from "react-toastify";
import PaxForm from "../../components/PaxForm/PaxForm";

const PaxEdit = props => {
  let { id, cid } = useParams();
  const [Loading, setLoading] = useState(false);
  const { PaxsData, setPaxsData, fetchData, CIDData, ReviewMode, LngLink, doLogout, Loading: ContextLoading } =
    useContext(GeneralContext);
  const hasLoggedOut = useRef(false);

  useEffect(() => {
    // Validar que el CID de la URL coincida con el CID autenticado
    if (!ContextLoading && CIDData && CIDData.IDInbox && !hasLoggedOut.current) {
      if (cid !== String(CIDData.IDInbox)) {
        // El CID de la URL no coincide con la reserva autenticada
        // Desloguear y redirigir al login
        hasLoggedOut.current = true;
        doLogout();
      }
    }
  }, [cid, CIDData, ContextLoading, doLogout]);

  useEffect(() => {
    // No hacer fetch si el CID no coincide (la validación se encargará del logout)
    if (!ContextLoading && CIDData && CIDData.IDInbox && cid !== String(CIDData.IDInbox)) {
      return;
    }
    if (!CIDData || !CIDData.IDInbox) {
      return;
    }
    if (!PaxsData) {
      setLoading(true);
      fetchData("PaxsData", CIDData.IDInbox)
        .then(res => {
          setPaxsData(res);
        })
        .catch(err => {
          // sin log: el objeto de error puede traer headers y cuerpo del pedido
          toast.error(err);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [cid, CIDData, ContextLoading]);

  // Si estamos cargando o no hay CIDData, mostrar el contenido normalmente
  // El efecto se encargará del logout si es necesario
  if (!ContextLoading && CIDData && CIDData.IDInbox && cid !== String(CIDData.IDInbox)) {
    // Redirigir mientras se procesa el logout
    return <Redirect to={LngLink + "/app/login"} />;
  }

  if (Loading)
    return (
      <Grid container justify="center" alignItems="center">
        <Grid item>
          <CircularProgress />
        </Grid>
      </Grid>
    );
  return (
    <Grid container>
      <Grid item xs={12} style={{ width: "100%" }}>
        <WizardStep activeStep={0} />
      </Grid>
      <Grid item xs={12}>
        <PageTitle
          previousPage={
            ReviewMode
              ? `${
                  LngLink + process.env.REACT_APP_ROOT_PATH_LINK
                }/checkin/${cid}/verify`
              : LngLink +
                process.env.REACT_APP_ROOT_PATH_LINK +
                `/checkin/${cid}/paxs`
          }
          title="paxs.title"
          description="paxs.description"
        />
      </Grid>
      <Grid item xs={12}>
        <Box pl={2} pr={2} pb={4}>
          <PaxForm paxId={id} cid={cid} />
        </Box>
      </Grid>
    </Grid>
  );
};

export default memo(PaxEdit);
